import { Transform } from 'class-transformer';
import { every, isEmpty, lowerFirst } from 'lodash';

/**
 * Utility transformer for class-transformer for mapping multiple prefixed properties into a single class that can then be validated with class-validator.
 */
export const TransformPropertiesToClass = (
  prefix: string,
  type: {
    new (): object;
  },
) =>
  Transform((params) => {
    const dto = new type();
    Object.keys(params.obj).reduce((dto, key) => {
      if (key.startsWith(prefix)) {
        const propertyKey = lowerFirst(key.replace(prefix, ''));
        (dto as any)[lowerFirst(propertyKey)] = params.obj[key]?.toString();
      }
      return dto;
    }, dto);
    // Check if every attribute of the object is empty, if yes return null
    return !every(dto, isEmpty) ? dto : null;
  });
